export default __webpack_public_path__ + "static/media/PrivateAndCookie.en.fdf7235a.md";